// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DOxD","title":"styles_title__1Adii"};